import { render, staticRenderFns } from "./OrderLogin.vue?vue&type=template&id=7436c8ad&"
import script from "./OrderLogin.vue?vue&type=script&lang=ts&"
export * from "./OrderLogin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports